"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.object.to-string");

var _require = require("./LoggerBase"),
    LoggerBase = _require.LoggerBase;

var _require2 = require("./LoggerFactoryBase"),
    LoggerFactoryBase = _require2.LoggerFactoryBase;

var _require3 = require("./LoggerFactoryWrapper"),
    LoggerFactoryWrapper = _require3.LoggerFactoryWrapper;

var _require4 = require("./Enums"),
    eLogLevel = _require4.eLogLevel,
    elasticLogLevel = _require4.elasticLogLevel;

var instanceKey = Symbol["for"]("888-logger-core");
var globalSymbols = Object.getOwnPropertySymbols(global);
var hasInstance = globalSymbols.indexOf(instanceKey) > -1;

if (!hasInstance) {
  global[instanceKey] = new LoggerFactoryWrapper();
}

function getLoggerFactoryWrapper() {
  return global[instanceKey];
}

exports.createLogger = function (category) {
  return getLoggerFactoryWrapper().createLogger(category);
};

exports.initLoggerFactory = function (loggerFactory) {
  getLoggerFactoryWrapper().initLoggerFactory(loggerFactory);
};

exports.LoggerBase = LoggerBase;
exports.LoggerFactoryBase = LoggerFactoryBase;
exports.eLogLevel = eLogLevel;
exports.elasticLogLevel = elasticLogLevel;